import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelRadio } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogos, cargarCatalogos_Otros, cargarCatalogosGenericoAsync, cargarCatalogosAsync } from '../../funciones_globales/catalogos';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { visualizarReporteEnPdf,generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';

import { getFechaProcesoPorModulo, getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';
import { formatearNumeroEntero } from '../../funciones_globales/format';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';

const COD_BOTON_SALDOCONTABLE = '090101';
const COD_BOTON_EXCEL = '090102';

class FormCartera05  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            periodo: '',
            mes_opt: [],
            mes_sel: null,
            anioActual: null,
            cliente_sel: null,
            oficialesCredito: [],
            ofCredito_sel: null,
            ciudad_sel: null,
            vendedor_sel: null,
            tipoSaldo: 'CLI',
            isVisibleBotonSaldoContab: false,
            tipoUsuario: null, //TipoUsuario = 3 Vendedor
            paramVendedor: null,
            isVisibleBotonExcel:false
        };

        this.generarReporteCuentasPorCobrar = this.generarReporteCuentasPorCobrar.bind(this);
        this.generarReporteCuentasPorCobrarExcel = this.generarReporteCuentasPorCobrarExcel.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.changeYear = this.changeYear.bind(this);
        
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
      }

    getOptions_Ciudad(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('CIUDAD', input, callback)
        }
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 2 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    changeYear(){
        if(this.state.periodo!==''){
            let anio = formatearNumeroEntero(this.state.periodo);
            let fechaInf = formatearNumeroEntero(this.state.anioActual) - 3;

            if(anio>formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
            }else if(anio===formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: anio});
            }else if(anio >= fechaInf && anio <=formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: anio});
            }else{
                this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
                alert("Sólo puede consultar información de los últimos 3 años.");
            }
        }
    }

    componentDidMount(){
        let usuario = getItemDatosSesion('usuario');
        Promise.all([
            cargarCatalogos_Otros('MESES'),
            cargarCatalogos_Otros('CLI-OFICIALES'),
            cargarCatalogos('PARAMVENDEDOR'),
            cargarPermisoBoton(COD_BOTON_SALDOCONTABLE, usuario),
            cargarPermisoBoton(COD_BOTON_EXCEL, usuario),
            this.props.generar_LogAuditoriaIngresoForm('0901'),
            
         ])
        .then(([ meses ,result_oficiales, paramVendedorResult ,configBotonSaldoContab,configBotonExcel ]) => {
            let fechaProceso = getFechaProcesoPorModulo('09');
            let isVisibleBotonSaldoContab = false;
            let isVisibleBotonExcel = false;

            if(configBotonExcel.display==='block'){
                isVisibleBotonExcel = true;
            }

            if(configBotonSaldoContab.display==='block'){
                isVisibleBotonSaldoContab = true;
            }
            let ArrayMeses = [];
            meses.forEach((MES)=>{
                
                if(MES.value !== '00'){
                    let item = {};
                    item.value = MES.value;
                    item.label = MES.label;
                    ArrayMeses.push(item);
                }
            })
            let fechaProceso1 = getFechaProcesoPorModulo('08').split('/');
            

            this.setState({ fechaCorte: moment(fechaProceso,'DD/MM/YYYY'),
                            tipoUsuario: this.props.tipoUsuario, oficialesCredito: result_oficiales,
                            paramVendedor: parseInt(paramVendedorResult[0].value,10),
                            isVisibleBotonSaldoContab,
                            isVisibleBotonExcel, 
                            mes_opt: ArrayMeses, mes_sel: fechaProceso1[1], periodo: fechaProceso1[2], anioActual: fechaProceso1[2]
            });
        })
        .catch(error => {
            alert(error);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0901');
    }
    generarReporteCuentasPorCobrarExcel(){
        var continuar = true;
        var error = "";

        let fechaProceso = getFechaProcesoPorModulo('09');
     
        if(this.state.tipoUsuario === this.state.paramVendedor){
            if(this.state.cliente_sel===null){
                continuar = false;
                error=error+`- Seleccione un cliente antes de continuar\n`;
            }
        }
        

        let valid = validarFechaMomentEnFormatoString(fechaProceso)
        if(valid===false){
            continuar = false;
            error=error+'- La fecha no está en el formato correcto.\n';
        }        
        
        if(continuar===true){
            let parametros = '&rpt=168&param1='+this.state.periodo

            parametros += '&param2='+this.state.mes_sel;

            if(this.state.cliente_sel!==null){
                parametros += '&param3='+this.state.cliente_sel.value;
            }

            if(this.state.ofCredito_sel!==null){
                parametros += '&param4='+this.state.ofCredito_sel;
            }

            if(this.state.ciudad_sel!==null){
                parametros +='&param5='+this.state.ciudad_sel.value;
            }

            if(this.state.vendedor_sel!==null){
                parametros += '&param6='+this.state.vendedor_sel.value;
            }

            if(this.state.tipoUsuario === this.state.paramVendedor){
                let usu =getItemDatosSesion('usuario') 

                parametros += '&param6='+usu;
                /*if(this.state.cliente_sel===null){
                    continuar = false;
                    error=error+`- Seleccione un cliente antes de continuar\n`;
                }*/
                
            }
            
            parametros+= `&param7=${this.state.tipoSaldo}`;

            generarReporteEnExcel(parametros);
        }else{
            alert(error);
        }
    }
    generarReporteCuentasPorCobrar(){
        var continuar = true;
        var error = "";
        
        
        
        let fechaProceso = getFechaProcesoPorModulo('09');
        
        /*
        if(this.state.tipoUsuario === this.state.paramVendedor){
            if(this.state.cliente_sel===null){
                continuar = false;
                error=error+`- Seleccione un cliente antes de continuar\n`;
            }

        }*/

        
        let valid = validarFechaMomentEnFormatoString(fechaProceso)
        if(valid===false){
            continuar = false;
            error=error+'- La fecha no está en el formato correcto.\n';
            
        }        
        
        if(continuar===true){
            let parametros = '&rpt=167&param1='+this.state.periodo;

            parametros += '&param2='+this.state.mes_sel;

            if(this.state.cliente_sel!==null){
                parametros += '&param3='+this.state.cliente_sel.value;
            }

            if(this.state.ofCredito_sel!==null){
                parametros += '&param4='+this.state.ofCredito_sel;
            }

            if(this.state.ciudad_sel!==null){
                parametros +='&param5='+this.state.ciudad_sel.value;
            }

            if(this.state.vendedor_sel!==null){
                parametros += '&param6='+this.state.vendedor_sel.value;
            }

            if(this.state.tipoUsuario === this.state.paramVendedor){
                let usu =getItemDatosSesion('usuario') 

                parametros += '&param6='+usu;
                /*if(this.state.cliente_sel===null){
                    continuar = false;
                    error=error+`- Seleccione un cliente antes de continuar\n`;
                }*/
                
            }
            
            parametros+= `&param7=${this.state.tipoSaldo}`;

            visualizarReporteEnPdf(parametros);
        }else{
            alert(error);
        }
    }

    limpiar(){
        

        this.setState({
            
            cliente_sel: null,
            ofCredito_sel: null,
            ciudad_sel: null,
            vendedor_sel: null,
            tipoSaldo: 'CLI'
        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={50}>
                <HeaderForm>
                    <TituloForm>Cuentas por Cobrar Historico</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    
                    
                    <Row>                        
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Periodo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <InputText name='periodo' value={this.state.periodo} type="number" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.changeYear(value)}}/>
                        </ContainerCol>
                    </Row>

                    <Row>
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Mes:</LabelForm>
                        </ContainerCol>                
                        <ContainerCol className='col-sm-4' margen_abajo='4'>
                            <ReactSelect options={ this.state.mes_opt } value={this.state.mes_sel} func_onChange={(value)=>{this.setState({mes_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row>

                    <Row margen_arriba={5} isInvisible={this.state.paramVendedor === this.state.tipoUsuario?true:false}>
                        <ContainerCol className='col-sm-7'>
                            <LabelForm>Subzona(Ciudad):</LabelForm>
                            <ReactSelectAsync value={this.state.ciudad_sel} func_loadOptions={this.getOptions_Ciudad} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({ciudad_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={5} isInvisible={this.state.paramVendedor === this.state.tipoUsuario?true:false}>
                        <ContainerCol className='col-sm-7'>
                            <LabelForm>Oficial de Crédito:</LabelForm>
                            <ReactSelect options={ this.state.oficialesCredito } value={this.state.ofCredito_sel} func_onChange={(value)=>{this.setState({ofCredito_sel: value!==null?value.value:null});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={5} isInvisible={this.state.paramVendedor === this.state.tipoUsuario?true:false}>
                        <ContainerCol className='col-sm-7'>
                            <LabelForm>Vendedor:</LabelForm>
                            <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores}
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({vendedor_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={5}>
                        <ContainerCol className='col-sm-7'>
                            <LabelForm>Cliente:</LabelForm>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({cliente_sel: value })}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={5}>
                        <ContainerCol className='col-sm-8'>
                            <LabelForm>Tipo de Saldo:</LabelForm>                                
                            <div>
                                <LabelRadio className='radio-inline'><input type='radio' value='CLI' name='tipoSaldo' checked={this.state.tipoSaldo==='CLI'}
                                    onChange={this.handleInputChange}/> Saldo Cliente</LabelRadio>
                                {this.state.isVisibleBotonSaldoContab?
                                    <LabelRadio className='radio-inline'><input type='radio' value='CON' name='tipoSaldo' checked={this.state.tipoSaldo==='CON'}
                                        onChange={this.handleInputChange}/> Saldo Contable</LabelRadio>
                                :null}
                            </div>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>    
                            {
                                this.state.isVisibleBotonExcel?
                                <button type='button' className='btn btn-success btn-sm' onClick={this.generarReporteCuentasPorCobrarExcel}><i className='fa fa-print fa-lg' aria-hidden='true'/> Imprimir Excel</button>                        
                                :null
                            }  
                              
                                <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporteCuentasPorCobrar}><i className='fa fa-print fa-lg' aria-hidden='true'/> Imprimir</button>  
                                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}


const mapStateToProps = ((state) => {
    return { tipoUsuario: state.sesion.valoresSesionForm.TipoUsuario }
});
 
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCartera05);